/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit More/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaIconMoreHoriz from 'DesignSystem/Svgs/TysiaIconMoreHoriz/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function More({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More",
  setOuterRef,
  onClick,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected,
  left,
  top,
  setInnerRef
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="More.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<button
  data-testid="More.Vertical:1"
  data-view-path={viewPath}
 ref={setOuterRef}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-aA7k': hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconMoreHoriz
  viewPath={`${viewPath}/TysiaIconMoreHoriz`}
 width={16}
 height={16}
 fill={selected ? dtColorsWhite : dtColorsWhite}
/>
</button>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 setInnerRef={setInnerRef}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}